import { getPinnedAutomationLatestRunLinksQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/automationKeys.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
const NO_LINKS = Object.freeze({});
/**
 * Batch-loads latest-run links for pinned automations that Recents does not
 * already cover. The PINNED group cannot filter by ID, so it is read whole and
 * only the requested IDs are kept. No request is made for an empty ID list, and
 * the Relay client is dynamically imported so that case does not load it.
 */
export function usePinnedAutomationLatestRunLinks(automationIds) {
    const sortedIds = [...automationIds].sort();
    const { data } = useQuery({
        queryKey: [...getPinnedAutomationLatestRunLinksQueryKey(), sortedIds],
        queryFn: async () => {
            const { fetchSidebarPinnedAutomationLinks } = await import('#pplx/frontend/apps/ask/hooks/recent-items-query-hooks/sidebarPinnedAutomationLinks.js');
            const links = await fetchSidebarPinnedAutomationLinks();
            return Object.fromEntries(sortedIds.flatMap((automationId) => {
                const link = links[automationId];
                return link === undefined ? [] : [[automationId, link]];
            }));
        },
        enabled: sortedIds.length > 0,
        staleTime: 30_000,
    });
    return data ?? NO_LINKS;
}
//# sourceMappingURL=usePinnedAutomationLatestRunLinks.js.map